


















































































import Vue from 'vue';
import { ConfigKeys, Setting } from '@/types';
import { Utils } from '@/Utils';

interface Data {
    settings: Record<ConfigKeys, Partial<Setting>>;
}

export default Vue.extend({
    data: function(): Data {
        return {
            settings: {
                [ConfigKeys.DefaultReplyTo]: {
                    configKey: ConfigKeys.DefaultReplyTo,
                },
                [ConfigKeys.SFConsumerKey]: {
                    configKey: ConfigKeys.SFConsumerKey,
                },
                [ConfigKeys.SFConsumerSecret]: {
                    configKey: ConfigKeys.SFConsumerSecret,
                },
                [ConfigKeys.SFRefreshToken]: {
                    configKey: ConfigKeys.SFRefreshToken,
                },
                [ConfigKeys.SFBaseUrl]: {
                    configKey: ConfigKeys.SFBaseUrl,
                },
            },
        };
    },
    created: function() {
        this.fetchSettings().then(this.updateSettings);
    },
    methods: {
        async fetchSettings() {
            const configs = await Promise.all([
                Utils.fetchSetting(ConfigKeys.DefaultReplyTo),
                Utils.fetchSetting(ConfigKeys.SFConsumerKey),
                Utils.fetchSetting(ConfigKeys.SFConsumerSecret),
                Utils.fetchSetting(ConfigKeys.SFRefreshToken),
                Utils.fetchSetting(ConfigKeys.SFBaseUrl)
            ]);

            return configs;
        },
        openSettingsModal() {
            this.fetchSettings().then(this.updateSettings);
        },
        updateSettings(configs: Setting[]) {
            const newSettings: Partial<Record<
                ConfigKeys,
                Setting
            >> = configs.reduce((acc, setting) => {
                acc[setting.configKey] = setting;
                return acc;
            }, {});

            this.settings = {
                ...this.settings,
                ...newSettings,
            };
        },
        saveSettings(): void {
            const configs: Setting[] = Object.keys(this.settings)
                .filter<ConfigKeys>(
                    (prop: string | ConfigKeys): prop is ConfigKeys => {
                        return !!Object.values(ConfigKeys).includes(
                            prop as ConfigKeys
                        );
                    }
                )
                .map((cfgKey: ConfigKeys) => {
                    return this.settings[cfgKey];
                })
                .filter((cfg: Partial<Setting>): cfg is Setting => {
                    return (
                        cfg.configValue !== null &&
                        cfg.configValue !== undefined
                    );
                });

            Promise.all(configs.map(cfg => Utils.updateSetting(cfg)))
                .then((settings: Setting[]) => {
                    this.updateSettings(settings);
                    Utils.toastSuccess('Settings updated');
                })
                .catch(() => {
                    Utils.toastError('Failed to update settings');
                });
        },
    },
});
